// React
import React, {useState} from "react";
// Redux imports
import { useSelector, useDispatch } from "react-redux";
import { setProyecto } from "../../../redux/reducers/proyectos";

// import BooleanIcon from 'calcite-ui-icons-react/BooleanIcon';

import ActionBar, {
  Action,
  ActionGroup,
  // BottomActionGroup
} from 'calcite-react/ActionBar';

// Styled Components
import styled from "styled-components";

const ActionBarLeft = styled.div`
  // float:left;
  // display: inline-flex;
  // position: relative;
  // width: auto;
  // height: 100%;
  // text-align: center;
  // z-index: 2;
  // left: 0px;
  overflow: hidden;
  // background-color: #4c4c4c;
  // color: #fff;
`;

const ItemMenuOptsIcon = styled.div`
  width: 16px;
  height: 16px;
  background: transpararent;
  font-size:0.95rem;
  font-weight:700;
  text-align: center;
`;

const MenuLeftFondoAsisSocial = props => {
    // const isCollapsed = useSelector(state => state.proyectos.collapsed);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const activeAction = useSelector(state => state.proyectos.activeProyecto);
    const dispatch = useDispatch();

    const proyectosNames = {
      "":'Caracterización Social y Económica',
      "ACOMPAÑAMIENTO_FONDOASISOCIAL": "Acompañamiento individual y familiar",
			"CALAMIDADDOMESTICA": "Calamidad doméstica",
			"LIBRETAMILITAR": "Libreta militar",
      "APOYOADICIONAL": "Apoyo adicional",
      "CONFIGURACION": "Configuración del GRB", 
    };

    // useEffect(() => {
    //   dispatch(moduleLEFTPANELLoaded({activeModule:activeAction, headerTitle:proyectosNames[activeAction]}));
    // }, [dispatch]);

    const onToggleCollapse = (e) => {
      setIsCollapsed(!isCollapsed);
    };

    const turnOffModules = () => {
      // dispatch(moduleUSERSLoaded({loaded:false})); // Hide Users
      // dispatch(moduleBENEFICIARIOSLoaded({loaded:false}));
    }

    const actionSelected = (activeAction) => {
      dispatch(setProyecto({activeProyecto:activeAction, collapsed:isCollapsed, headerTitle:proyectosNames[activeAction]}));
      turnOffModules();
      switch (activeAction) {
        case 'ACOMPAÑAMIENTO_FONDOASISOCIAL':
          console.log('ACOMPAÑAMIENTO_FONDOASISOCIAL');
          break;
        case 'CALAMIDADDOMESTICA':
          console.log('CALAMIDADDOMESTICA');
          break;
        case 'LIBRETAMILITAR':
          console.log('LIBRETAMILITAR');
          break;
        case 'APOYOADICIONAL':
          console.log('APOYOADICIONAL');
          break;
        default:
          break;
      }
    };

    return (
      <ActionBarLeft>
      <ActionBar 
        // showCollapser={false}
        collapseLabel='Ocultar' 
        expandLabel='Expandir' 
        collapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
      >
        <ActionGroup>
          <Action
            onClick={() => actionSelected('ACOMPAÑAMIENTO_FONDOASISOCIAL')}
            active={activeAction === 'ACOMPAÑAMIENTO_FONDOASISOCIAL'}
            icon={<ItemMenuOptsIcon>A</ItemMenuOptsIcon>}
          >
            Acompañamiento
          </Action>
          <Action 
              onClick={() => actionSelected('CALAMIDADDOMESTICA')}
              active={activeAction === 'CALAMIDADDOMESTICA'}
              icon={<ItemMenuOptsIcon>CD</ItemMenuOptsIcon>}
            >
            Calamidad doméstica
          </Action>
          <Action
            onClick={() => actionSelected('LIBRETAMILITAR')}
            active={activeAction === 'LIBRETAMILITAR'}
            icon={<ItemMenuOptsIcon>LM</ItemMenuOptsIcon>}
          >
            Libreta militar
          </Action>
        <Action
          onClick={() => actionSelected('APOYOADICIONAL')}
          active={activeAction === 'APOYOADICIONAL'}
          icon={<ItemMenuOptsIcon>AA</ItemMenuOptsIcon>}
          >Apoyo adicional</Action>
        </ActionGroup>
        {/* <BottomActionGroup>
        <Action icon={<GearIcon />}>Configuración</Action>
      </BottomActionGroup> */}
      </ActionBar>
      </ActionBarLeft>
    )

}

export default MenuLeftFondoAsisSocial;